import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {localesFeatureKey, localesReducer, LocalesState} from '@emm/shared/store/locales/locales.reducers';
import {themeFeatureKey, themeReducer, ThemeState} from '@emm/shared/store/theme/theme.reducers';
import {showTagsFeatureKey, showTagsReducer, ShowTagsState} from '@emm/shared/store/show-tags/show-tags.reducers';


export const sharedFeatureKey = 'shared';

export interface SharedState {
    [localesFeatureKey]: LocalesState;
    [themeFeatureKey]: ThemeState;
    [showTagsFeatureKey]: ShowTagsState;
}

export interface State extends CoreState {
    [sharedFeatureKey]: SharedState;
}

export function sharedReducers(state: SharedState, action: Action) {
    return combineReducers({
        [localesFeatureKey]: localesReducer,
        [themeFeatureKey]: themeReducer,
        [showTagsFeatureKey]: showTagsReducer
    })(state, action);
}

export const getSharedState = createFeatureSelector<State, SharedState>(sharedFeatureKey);
